import api from '../axiosConfig';

const API_URL = '/api/purity'; 

export const fetchPurities = () => api.get(API_URL);
export const createPurity = (data) => api.post(API_URL, data);
export const updatePurity = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deletePurity = (id) => api.delete(`${API_URL}/${id}`);
